import {Mutation, State} from "vuex-class";
import {MarkaVozila, ModelVozila, Vozilo} from "@/services/BackendProxies";
import dataProxy from "@/services/data-proxy.service";
import {mixins} from "vue-class-component";
import {ComponentBaseMixin} from "@/mixins/component-base.mixin";



export class TabBase extends mixins(ComponentBaseMixin){
    @State vozilo: Vozilo;
    @Mutation setVozilo;

    currentTab = 0;
    marke = [];
    modeli = [];
    statusi = [];
    orgStrukture = [];
    pripada = '';
    aktivan: boolean;
    isBusy = false;
    kategorijeVozila = [];
    tipoviMotora = [];

    async load() {
        const id = +this.$route.params.id;
        if (id) {
            this.isBusy = true;
            try {
                this.orgStrukture = await dataProxy.vratiOrganizacioneJedinice();
                this.statusi = await dataProxy.vratiStatuseVozila();
                this.marke = await dataProxy.vratiMarkeVozila();
                this.modeli = this.marke.reduce((acc: ModelVozila[], marka: MarkaVozila) => acc.concat(marka.modeliVozila), []);
                this.kategorijeVozila = await dataProxy.vratiKategorijeVozila();
                this.tipoviMotora = await dataProxy.vratiTipoveMotoraVozila();
                const vozilo = await this.loadData<Vozilo>(() => dataProxy.vratiVozilo(id))();
                this.setVozilo(vozilo);
                this.currentTab = 0;
                this.isBusy = false;
            } catch (err) {
                this.isBusy = false;
            }
        }
    }
}
